export * from "./schema-hotel-page";
